module.exports = __webpack_public_path__ + "media/service_features/support_person-5cc8276e.svg";